export default __webpack_public_path__ + "static/media/letmeask-logo-2.8677b48c.png";